<template>
  <div class="slider" id="slider">
    <div class="slider__column">
      <div class="slider__column-bg img-w">
        <img src="@/assets/img/slider-bg.png" alt="">
      </div>
      <div class="slider__column-line img-w">
        <img src="@/assets/img/main-line.png" alt="">
      </div>
      <div class="slider__column-logo img-w">
        <img src="@/assets/img/logo.png" alt="">
      </div>
      <p class="slider__text">
        {{ 'За последние годы жизнь в России кардинально поменялась. Власти начали обращать внимание на нужды простых людей. На государственном уровне приняты законы, которые избавляют граждан от множества проблем: в стране расширили программу материнского капитала, увеличили объемы социальной помощи, упростили процесс записи детей в школы и детские сады.' | typograf }}
      </p>
      <p class="slider__text-bold">
        {{ 'Как эти преобразования улучшили жизнь миллионов людей и изменили всю страну? Об этом рассказывают сами россияне.' | typograf }}
      </p>
      <div class="slider__arrow img-w">
        <img src="@/assets/img/slider-arrow.png" alt="">
      </div>
      <div class="slider__column-bg2 img-w">
        <img src="@/assets/img/slider-bg2.png" alt="">
      </div>
    </div>

    <div class="slider__wrapper">
      <div class="slider__slides">
        <div class="slider__slide" v-for="(article, index) in articles" :key="index" >
          <router-link :to="`/article/${index + 1}`">
            <img class="mobile-hidden slider__slide-img" :src="require(`@/assets/img/slides/${index + 1}.png`)" alt="">
            <img class="mobile-hidden slider__slide-img-wide" :src="require(`@/assets/img/slides/${index + 1}-wide.jpg`)" alt="">
            <img class="mobile-visible slider__slide-img" :src="require(`@/assets/img/slides/${index + 1}-mob.png`)" alt="">
            <img class="mobile-visible slider__slide-img-wide" :src="require(`@/assets/img/slides/${index + 1}-mob-wide.png`)" alt="">
            <div class="slider__slide-title">
              {{ article | typograf }}
            </div>
          </router-link>
        </div>
      </div>
      <div v-if="showLeftArrow" class="slider__slides-arrow -left" @click="slide('left', 10, 250, 10)">
        <div class="slider__slides-arrow-icon img-w">
          <img src="@/assets/img/arrow.png" alt="">
        </div>
      </div>
      <div v-if="showRightArrow" class="slider__slides-arrow" @click="slide('right', 10, 250, 10)">
        <div class="slider__slides-arrow-icon img-w">
          <img src="@/assets/img/arrow.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './slider.styl'

export default {
  name: 'Slider',
  data () {
    return {
      showLeftArrow: null,
      showRightArrow: true,
      timer: null,
      articles: [
        'В России миллионы матерей-одиночек с детьми. Как государство помогло им справиться с трудностями в жизни?',
        'От жестокости людей страдают тысячи животных. Как в России нашли способ их спасти?',
        'Миллионы россиян боялись потерять свои гаражи. Почему теперь такой опасности нет?',
        'Детей по всей России разлучали с братьями и сестрами в школах и детских садах. Как эту ситуацию удалось исправить?',
        'Миллионы россиян боялись брать больничный по уходу за ребенком. Почему теперь это изменится?',
        'Тысячи россиян не могли устроить детям летний отдых. Как власти нашли способ им помочь?',
        'Многие россияне отапливают свои дома дровами. Теперь к ним бесплатно проведут газ',
        'Тысячи российских фермеров не могли продать свои продукты. Как их спасло массовое открытие ярмарок?'
      ]
    }
  },
  methods: {
    sideScroll (element, direction, speed, distance, step) {
      let scrollAmount = 0
      const slideTimer = setInterval(() => {
        if (direction === 'left') {
          element.scrollLeft -= step

          this.showLeftArrow = +element.scrollLeft

          this.showRightArrow = true
        } else {
          element.scrollLeft += step

          this.showLeftArrow = true

          if (element.offsetWidth + element.scrollLeft >= element.scrollWidth) {
            this.showRightArrow = null
          } else {
            this.showRightArrow = +element.scrollLeft
          }
        }
        scrollAmount += step
        if (scrollAmount >= distance) {
          window.clearInterval(slideTimer)
        }
      }, speed)
    },
    slide (d, s, di, st) {
      const target = document.querySelector('.slider__wrapper')
      this.sideScroll(target, d, s, di, st)
    }
  },
  mounted () {
    document.querySelector('html').scrollTo({
      top: 0,
      behavior: 'smooth'
    })
    if (document.documentElement.clientWidth > 1025) {
      const target = document.querySelector('.slider__wrapper')

      target.addEventListener('wheel', event => {
        event.stopPropagation()
        const toLeft = event.deltaY < 0 && target.scrollLeft > 0
        const toRight = event.deltaY > 0 && target.scrollLeft < target.scrollWidth - target.clientWidth

        if (event.deltaY < 0 && target.scrollLeft === 0) {
          this.$store.commit('UNLOCK_SCREEN_CHANGE')
        }
        if (toLeft) {
          event.preventDefault()
          target.scrollLeft += event.deltaY
          this.showLeftArrow = +target.scrollLeft

          this.showRightArrow = true
        } else if (toRight) {
          this.$store.commit('LOCK_SCREEN_CHANGE')
          target.scrollLeft += event.deltaY

          this.showLeftArrow = true

          if (target.offsetWidth + target.scrollLeft >= target.scrollWidth) {
            this.showRightArrow = null
          } else {
            this.showRightArrow = +target.scrollLeft
          }
        }
      })
    }
  },
  destroyed () {

  }
}
</script>

<style lang="stylus">
.slider__slide.is-hidden
  display: none !important
</style>
